<script lang="ts">
    import {createEventDispatcher, onMount} from "svelte";
    import PortalView from "../../../component/common/Portal/PortalView.svelte";
    import EditDialogView from "../../../component/common/Dialog/EditDialogView.svelte";
    import LabelValueView from "../../../component/common/Value/LabelValueView.svelte";
    import InputAreaView from "../../../component/common/Form/InputAreaView.svelte";
    import {UrlUtil} from "../../../lib/Common/Http/UrlUtil";
    import {HttpRequestUtil} from "../../../lib/Common/Http/HttpRequestUtil";

    const dispatcher = createEventDispatcher();

    export let space;
    export let editData;

    let isLoading = false;

    onMount(() => {
    });

    function onShow() {

    }

    function save() {


        const url = UrlUtil.createApiUrl("app");

        isLoading = true;
        HttpRequestUtil.postRequest(url, editData, (response) => {
            isLoading = false;
            console.log(response);
            const body = response['body'];

            close();

            dispatcher('update');

        });
    }

    function close() {
        dispatcher('close');

    }

    function onDelete() {
        const url = UrlUtil.createApiUrl("app");

        isLoading = true;
        HttpRequestUtil.deleteRequest(url, editData, (response) => {
            isLoading = false;
            console.log(response);
            const body = response['body'];

            close();

            dispatcher('update');

        });
    }

</script>

<PortalView>
    <EditDialogView
            title="アプリ編集"
            editData={editData}
            on:save={save}
            canDelete={true}
            on:delete={onDelete}
            on:show={onShow} on:cancel={close}>
        <div class="app-edit-dialog-content">
            <div>
                <LabelValueView label="スペース名" value={space.name}/>
            </div>

            <div>
                <div class="row">
                    <InputAreaView label="アプリ名">
                        <input type="text" placeholder="アプリ名" bind:value={editData.name}>

                    </InputAreaView>
                </div>
                <div class="row">
                    <InputAreaView label="説明">
                        <input type="text" placeholder="説明" bind:value={editData.description}>

                    </InputAreaView>
                </div>

                <div class="row">
                    <InputAreaView label="バージョンカウント">
                        <input type="number" placeholder="バージョンカウント" bind:value={editData.version_count}>

                    </InputAreaView>
                </div>
            </div>

        </div>

    </EditDialogView>
</PortalView>


<style lang="scss">
    .app-edit-dialog-content {

    }
</style>